export const mentalityConfig = {
    title: '精神状态评估表',
    explain: '能力完好：总分0分；轻度受损：总分1分；中度受损：总分2-3分；重度受损：总分4-6分',
    result: totleScore => {
        let result = '';
        switch (true) {
            case totleScore === 0:
                result = '能力完好';
                break;
            case totleScore === 1:
                result = '轻度受损';
                break;
            case totleScore <= 3 && totleScore >= 2:
                result = '中度受损';
                break;
            default:
                result = '重度受损';
                break;
        }
        return result;
    },
    qus: [
        {
            title: '认知功能：',
            tip: (
                <div style={{ marginBottom: 8 }}>
                    <div>
                        测试：“我说三样东西，请重复一遍，并记住，一会儿会问您”：苹果、手表、国旗
                    </div>
                    <div>（1）画钟测试：“请在这儿画一个圆形时钟，在时钟上标出10点45分”</div>
                    <div>（2）回忆词语：“现在请您告诉我，刚才我要您记住的三样东西是什么？”</div>
                    <div>答：______、______、______（不必按顺序）</div>
                </div>
            ),
            options: [
                {
                    label: '画钟正确（画出一个闭锁圆，指针位置准确），且能回忆出2-3个词',
                    score: 0,
                },
                {
                    label: '画钟错误（画的圆不闭锁，或指针位置不准确），或只回忆出0-1个词',
                    score: 1,
                },
                { label: '已确诊为认知障碍，如老年痴呆', score: 2 },
            ],
        },
        {
            title: '攻击行为：',
            options: [
                {
                    label: '无身体攻击行为（如打/踢/推/咬/抓/摔东西）和语言攻击行为（如骂人、语言威胁、尖叫）',
                    score: 0,
                },
                { label: '每月有几次身体攻击行为，或每周有几次语言攻击行为', score: 1 },
                { label: '每周有几次身体攻击行为，或每日有语言攻击行为', score: 2 },
            ],
        },
        {
            title: '抑郁症状：',
            options: [
                { label: '无', score: 0 },
                { label: '情绪低落、不爱说话、不爱梳洗、不爱活动', score: 1 },
                { label: '有自杀念头或自杀行为', score: 2 },
            ],
        },
    ],
};
